import React, {useState, useEffect, useCallback} from "react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "./App.css";

import ConfigurationViewService from './services/configurationview.service.js';

import CompanyNameEntry from "./components/CompanyNameEntry";

import Layout from "./components/Layout";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";

import { logout } from "./slices/auth";
import EventBus from "./common/EventBus";

import ErrorBoundary from './ErrorBoundary'; // To avoid any errors appearing on browser


function App() {
  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const { user: currentUser } = useSelector((state) => state.auth);
  //console.log(currentUser)
  const dispatch = useDispatch(); // Get dispatch from Redux

  const[logoutDN, setLogoutDN] = useState(false);
  const[loginScreenStatus, setLoginScreenStatus] = useState("Enabled")
  const [rememberMe, setRememberMe] = useState(false);

  // below function will get executed when user token get expired.
  const logOut = useCallback(() => {
    // Here with imported { logout } from "./slices/auth"; will get dispatched.
    dispatch(logout());
  }, [dispatch]);

  // Get Login Windows Enable/Disable Status
  //Get configuration of the selected widget
  useEffect(() =>{
    async function getColumnData()  {
    try {

      let dashboardName = "ApplicationConfig";
      const response = await ConfigurationViewService.getLoginScreenStatus(dashboardName);

      //console.log(response.data);
      setLoginScreenStatus(response.data.TaskStatus)
      if (response.status === 200) {
        //console.log("Login successful", JSON.stringify(response.data));
        if (response.data.TaskStatus === "Disabled"){
          localStorage.removeItem("user");
          sessionStorage.removeItem("user");
          localStorage.removeItem("rememberMe");

          if (response.data.username) {
            localStorage.setItem("user", JSON.stringify(response.data));   
            sessionStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("rememberMe", JSON.stringify({ "rememberMe": rememberMe }));
          }
        }
        
        //return response.data;
      } else {
        console.error("Unexpected response status:", response.status);
        // Handle non-200 status codes appropriately
      }
      
    } catch (error) {
      console.log(error);

    }
  }
  getColumnData();



  }, []);

  // when token get expire, currentUser will become null and below useEffect will get executed and then user will get logout automatically from application
  useEffect(() => {
    
    if (currentUser) {
      if(currentUser.role === "supervisor"){
        setShowModeratorBoard(true);
      }
      if(currentUser.role === "Admin"){
        setShowAdminBoard(true);
      }
      
      
    } else {
      setShowModeratorBoard(false);
      setShowAdminBoard(false);

    }

    EventBus.on("logout", () => {
      //console.log("LOGOUT EVENT RECEIVED IN APP");
      // Execute below function to perform logout action
      setLogoutDN(true);
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [currentUser, logOut]);

  /////////////////////////////
  // Prevent openng dupicate tab
  useEffect(() => {
    const hasOpenedApp = sessionStorage.getItem('hasOpenedApp');
    if (hasOpenedApp) {
      // App is already opened in another tab
      sessionStorage.removeItem('hasOpenedApp'); // Clear the flag
      alert('You have already opened the application in another tab. Close this tab to avoid autologout from application,  even if you are performing operations on first tab.');
      window.close(); // Close the tab
      //window.location.href = window.location.origin; // Redirect to the first tab
    } else {
      // Set flag indicating the app is opened
      sessionStorage.setItem('hasOpenedApp', true);
    }

    // Cleanup on component unmount
    return () => {
      sessionStorage.removeItem('hasOpenedApp');
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      // Remove the flag on tab close
      sessionStorage.removeItem('hasOpenedApp');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  ///////////////////////////////


  return (
    <Router>
      
    <div>
      <div >
      <ErrorBoundary>

        <Routes>

          {/* --- NEW: Default page is Company name Entry Page --- */}
          <Route path="/" element={<CompanyNameEntry />} />

          {/* When user is redirected to correct company URL (like /company1/login),
              your normal login/layout routing will work automatically */}

          {loginScreenStatus === "Disabled" && <Route path="/layout" element={<Layout />} />}
          {loginScreenStatus === "Disabled" && <Route path="/login" element={<Layout />} />}

          {(loginScreenStatus === "Enabled" && currentUser) && (
            <Route path="/layout" element={<Layout />} />
          )}

          {loginScreenStatus === "Enabled" && (
            <Route path="/login" element={<SignIn />} />
          )}

          {(loginScreenStatus === "Enabled" && logoutDN) && (
            <Route path="/login" element={<SignIn />} />
          )}

        </Routes>


      </ErrorBoundary>
      </div>
    </div>

    </Router>
    
  );
}

export default App;